import {
  Radio,
  RadioGroup,
  RadioGroupProps,
  RadioOverrides,
} from 'baseui/radio';
import * as React from 'react';
import merge from 'ts-deepmerge';

interface Props extends RadioGroupProps {
  options: { value: string; label: string }[];
}

export default function MasterRadioInput(props: Props) {
  const { overrides: _overrides, options, ...rest } = props;
  const overrides = merge(
    {
      RadioMarkOuter: {
        style: ({ $theme, $checked, $disabled }) => ({
          backgroundColor: '#FFFFFF',
          border: `1.6px solid ${
            $disabled
              ? $theme.colors.skyLight
              : $checked
              ? $theme.colors.primaryDark
              : $theme.colors.inkLightest
          }`,
        }),
      },
      RadioMarkInner: {
        style: ({ $theme, $checked, $disabled }) => ({
          width: '12px',
          height: '12px',
          backgroundColor: $checked
            ? $disabled
              ? $theme.colors.skyLight
              : $theme.colors.primaryDark
            : null,
        }),
      },
      Label: {
        style: ({ $theme }) => ({
          ...$theme.typography.ParagraphMedium,
        }),
      },
    } as RadioOverrides,
    { ..._overrides },
  );

  return (
    <RadioGroup {...rest} labelPlacement="right" overrides={overrides}>
      {options.map((option) => (
        <Radio
          key={option.value}
          value={option.value?.toString()}
          overrides={overrides}
        >
          {option?.label || ''}
        </Radio>
      ))}
    </RadioGroup>
  );
}
